import { createTelemetry, createTelemetryObject } from '@shared/core/analytics';

export type BrandCardType = 'brandPromoMosaic' | 'navbar' | 'productGrid' | 'categoryCarousel';

type ButtonInteractionType = { brandName: string; cardType: BrandCardType };

export const paidAdsForShopTelemetry = createTelemetryObject({
  actions: {
    brandCardClicked: ({ brandName, cardType }: ButtonInteractionType) => ({
      category: 'PaidAdsForShop',
      action: 'ButtonInteracted',
      label: 'BrandCardClicked',
      actionType: 'click',
      extraInfo: {
        brandName,
        cardType,
      },
    }),
  },
});

const { TelemetryProvider: PaidAdsForShopTelemetryProvider, useTelemetry: usePaidAdsForShopTelemetry } = createTelemetry(paidAdsForShopTelemetry);

type PaidAdsForShopTelemetry = ReturnType<typeof usePaidAdsForShopTelemetry>;

export { PaidAdsForShopTelemetryProvider, usePaidAdsForShopTelemetry, PaidAdsForShopTelemetry };
